import React from "react";
import SidebarItem from "./SidebarItem";
import { useNavigate, useParams } from "react-router-dom";
import { getCoursePath } from "@/lib/utils";
import { CourseSection } from "@/data/courseSections";

type SidebarSectionProps = {
  number: number;
  section: CourseSection;
  expanded: boolean;
  onToggle: () => void;
};

const SidebarSection = ({
  section,
  number,
  expanded,
  onToggle,
}: SidebarSectionProps) => {
  const navigate = useNavigate();
  const { courseSlug, sectionId, lessonId } = useParams();

  const navigateToLesson = (sectionSlug: string, lessonSlug: string) => {
    navigate(
      `/course/${courseSlug}/section/${sectionSlug}/lesson/${lessonSlug}`,
    );
  };

  return (
    <SidebarItem
      number={number}
      title={section.title}
      hasChildren={true}
      expanded={expanded}
      onClick={onToggle}
      locked={section.locked}
    >
      {section.lessons?.map((subsection, index) => (
        <SidebarItem
          key={subsection.slug}
          number={index + 1}
          title={subsection.title}
          active={lessonId === subsection.slug}
          onNavigate={() => navigateToLesson(section.slug, subsection.slug)}
          locked={subsection.locked}
        />
      ))}
    </SidebarItem>
  );
};

export default SidebarSection;
